// In-app feedback (STORY-016). Context is plain JSON the user sees listed in the
// sheet before sending: no audio, no transcript beyond the current sentence.

import { getStoredAuth } from './sync';
import { sentenceKey } from './history';

const SEND_TIMEOUT_MS = 15000;

/** @param {Object} s videoId, lang, sentence ({start, text}), drill, scoreResult, asrEngine, signedIn */
export function buildFeedbackContext(s) {
  const drill = s.drill || {};
  const sentence = s.sentence || null;
  return {
    videoId: s.videoId || null,
    sentenceKey: s.videoId && sentence ? sentenceKey(s.videoId, s.lang, sentence.start) : null,
    sentence: sentence ? sentence.text : null,
    drillStatus: drill.status || null,
    asrError: drill.asrError || null,
    lastScore: s.scoreResult && s.scoreResult.accuracy !== undefined ? s.scoreResult.accuracy : null,
    attemptNumber: drill.attemptNumber || null,
    asrEngine: s.asrEngine || null,
    signedIn: !!s.signedIn,
    userAgent: navigator.userAgent,
    viewport: window.innerWidth + 'x' + window.innerHeight,
    path: window.location.pathname + window.location.search,
    at: new Date().toISOString()
  };
}

/** Rejects with an Error whose `code` is RATE_LIMITED, INVALID, NETWORK or FAILED. */
export async function sendFeedback(report) {
  const headers = { 'Content-Type': 'application/json' };
  const auth = getStoredAuth();
  if (auth && auth.token) headers.Authorization = 'Bearer ' + auth.token;

  const controller = new AbortController();
  const timer = setTimeout(function() { controller.abort(); }, SEND_TIMEOUT_MS);
  let res;
  try {
    res = await fetch(process.env.TRANSCRIPT_API_URL + '/v1/feedback', {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(report),
      signal: controller.signal
    });
  } catch (_) {
    throw feedbackError('NETWORK');
  } finally {
    clearTimeout(timer);
  }
  if (res.status === 429) throw feedbackError('RATE_LIMITED');
  if (res.status === 422 || res.status === 413) throw feedbackError('INVALID');
  if (!res.ok) throw feedbackError('FAILED');
}

function feedbackError(code) {
  const err = new Error(code);
  err.code = code;
  return err;
}
